import z from "zod";

export const absenceManagerDataSchema = z.object({});

export type AbsenceManagerDataProps = z.infer<typeof absenceManagerDataSchema>;
